import React from "react";
import {useTranslation} from "react-i18next";
import EditIcon from '@mui/icons-material/Edit';
import {SecondaryButton} from "./SecondaryButton";
import {useTheme} from "@mui/material";

export function OutlinedEditButton(props: {
  onClick: () => void,
  title?: string
}) {
  const {t} = useTranslation();
  const theme = useTheme();
  return (
    <SecondaryButton sx={{
      color: 'text.secondary',
      backgroundColor: 'background.light',
      borderColor: 'secondary.main',
      minWidth: 150,
      marginLeft: theme.spacing(1),
    }} onClick={props.onClick} startIcon={<EditIcon/>} title={props.title || t('buttons.edit')}/>
  )
}
